import clsx from "clsx";
import React, { ButtonHTMLAttributes, DetailedHTMLProps } from "react";

type OptionalTileProps = {
  color?: "accent" | "primary" | "secondary";
  componentStyle?: "default" | "inverted";
} & React.PropsWithChildren &
  React.HTMLAttributes<HTMLElement> &
  DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

type RequiredTileProps = {
  label: string | TrustedHTML;
  value: string;
};

export type CommonTileProps = OptionalTileProps & RequiredTileProps;

export function createTileClassNames(
  { className, color, componentStyle }: OptionalTileProps,
  variant: "default" | "stacked",
) {
  return clsx(
    {
      [`tile`]: true,
      [`tile--is-default`]: !variant || variant === "default",
      [`tile--is-stacked`]: variant === "stacked",
      [`tile--is-accent`]: color === "accent",
      [`tile--is-primary`]: color === "primary" || !color,
      [`tile--is-secondary`]: color === "secondary",
      [`tile--is-inverted`]: componentStyle === "inverted",
    },
    className,
  );
}
